const colors = {
  primary: '#FF6060',
  backgroundLight: '#F6F6F6',
}

export default colors
